import { ReactElement } from 'react';
import { ColumnValueSlotProps } from './ChangeHistoryColumnValue';
import { IApiColumnProps, IApiColumnType } from '@tap/data-providers';
import { ChangeHistorySlotComponent } from './change-history.types';
import { SimpleColumnDiff } from './SimpleColumnDiff';
import { JsonColumnDiff } from './JsonColumnDiff';

export type ChangeHistoryColumnDiffProps = {
    title: string,
    oldValue: any,
    newValue: any,
    columnInfo?: IApiColumnProps,
    slots?: ChangeHistorySlotComponent<ColumnValueSlotProps>,
    slotProps?: ColumnValueSlotProps,
}

export const ChangeHistoryColumnDiff = (props: ChangeHistoryColumnDiffProps): ReactElement => {
    // TODO: Подумать над более логичным условием.
    if (props.columnInfo?.type === IApiColumnType.Json && props.columnInfo.jsonProps?.schemaName) {
        // Комплексный объект, содержащий несколько свойств
        return <JsonColumnDiff {...props} />
    } else {
        // Одно свойство
        return <SimpleColumnDiff {...props} />
    }
};
